/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The Storage model module.
 * @module model/Storage
 * @version 1.0.0
 */
class Storage {
    /**
     * Constructs a new <code>Storage</code>.
     * Usage of the filesystem the media lives on, in bytes.
     * @alias module:model/Storage
     */
    constructor() { 
        
        Storage.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Storage</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Storage} obj Optional instance to populate.
     * @return {module:model/Storage} The populated <code>Storage</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Storage();

            if (data.hasOwnProperty('totalBytes')) {
                obj['totalBytes'] = ApiClient.convertToType(data['totalBytes'], 'Number');
            }
            if (data.hasOwnProperty('usedBytes')) {
                obj['usedBytes'] = ApiClient.convertToType(data['usedBytes'], 'Number');
            }
            if (data.hasOwnProperty('freeBytes')) {
                obj['freeBytes'] = ApiClient.convertToType(data['freeBytes'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Storage</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Storage</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} totalBytes
 */
Storage.prototype['totalBytes'] = undefined;

/**
 * @member {Number} usedBytes
 */
Storage.prototype['usedBytes'] = undefined;

/**
 * @member {Number} freeBytes
 */
Storage.prototype['freeBytes'] = undefined;






export default Storage;

